<template>
    <div class="PersonalCenter">
        <div class="mainLeft">
            <div class="left-top">
                <div class="admin">
                    <div class="admin1">
                        <p>
                            <img :src="$store.state.imgUrl+userInfo.headImg" alt />
                        </p>
                        <p>{{userInfo.username}}</p>
                    </div>
<!--                    <div class="admin2">-->
<!--                        <p>绑定手机：</p>-->
<!--                        <p>{{userInfo.phone}}</p>-->
<!--                    </div>-->
                </div>
                <div class="topNav">
                    <ul>
                        <li
                            v-for="(item,index) in navList"
                            :key="index"
                            :class="{'active':i1==index}"
                            @click="select(index)"
                        >
                            <p class="navImg">
                                <img :src="item.img" alt />
                            </p>
                            <p class="navTitl">{{item.title}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="left-middle">
                <div class="orderList">
                    <div class="listWrap" v-for="(item,index) in list" :key="index">
                        <!-- 商品列表 -->
                        <div class="listWrap2" v-if="item.atType==1">
                            <div class="listImg" @click="goDetails(item.id)">
                                <img :src="item.ddmxList?$store.state.imgUrl+item.ddmxList[0].atPhotoUrl:''" alt />
                            </div>
                            <div class="listTxt" @click="goDetails(item.id)">
                                <p class="listTxt1">
                                    {{item.optDdzt === 0? '等待付款'
                                    : item.optDdzt === 1? '交易关闭'
                                    : item.optDdzt === 3? '等待发货'
                                    : item.optDdzt === 4? '等待收货'
                                    : item.optDdzt === 5? '等待评价'
                                    : item.optDdzt === 6? '退单中'
                                    : item.optDdzt === 7? '退单成功'
                                    : item.optDdzt === 9? '已开发票'
                                    : item.optDdzt === 10? '已完成'
                                    : item.optDdzt === 11? '待回复'
                                    : item.optDdzt === 12? '待用户确认'
                                    : item.optDdzt === 14? '部分退款'
                                    : '未知状态'}}</p>
                                <p class="listTxt2">{{getTime(item.updateDate)}}</p>
                            </div>
                            <div class="listBtn" style="float:right">
                                <!-- <p class="listBtn1">查看详情</p>
                                <p class="listBtn2">物流跟踪</p>-->
                                <p class="listBtn1 shou" @click="goDetails(item.id)">订单详情</p>
                                <!-- 待支付 -->
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 0"
                                    @click="cancel(item.id)"
                                >取消订单</p>
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 0"
                                    @click="payment(item.id)"
                                >立即付款</p>
                                <!-- 待收货 -->
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 4"
                                    @click="logistics(item.id)"
                                >查看物流</p>
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 4"
                                    @click="ConfirmReceipt(item.id)"
                                >确认收货</p>
                                <!-- 等待评价 -->
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 5 && item.optDdzt != 10"
                                    @click="evaluate(item.id,item.spSpgl)"
                                >立即评价</p>
                                <!-- <p class="listBtn1" v-if="item.optDdzt == 5 && item.optDdzt != 9">开具发票</p> -->
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt != 2"
                                    @click="Repurchase(item.id,item.atType)"
                                >再次购买</p>
                            </div>
                        </div>
                        <!-- 处方列表 -->
                        <div class="listWrap2" v-if="item.atType==2">
                            <div class="listImg" @click="goDetailsCF(item.id)">
                                <img src="@/assets/img/fangji.png" alt />
                            </div>
                            <div class="listTxt" @click="goDetailsCF(item.id)">
                                <p class="listTxt1">
                                    {{item.optDdzt === 0? '等待付款'
                                    : item.optDdzt === 1? '交易关闭'
                                    : item.optDdzt === 3? '等待发货'
                                    : item.optDdzt === 4? '等待收货'
                                    : item.optDdzt === 5? '等待评价'
                                    : item.optDdzt === 6? '退单中'
                                    : item.optDdzt === 7? '退单成功'
                                    : item.optDdzt === 9? '已开发票'
                                    : item.optDdzt === 10? '已完成'
                                    : item.optDdzt === 11? '待回复'
                                    : item.optDdzt === 12? '待用户确认'
                                    : item.optDdzt === 14? '部分退款'
                                    
                                    : '未知状态'}}</p>
                                <p class="listTxt2">{{getTime(item.updateDate)}}</p>
                            </div>
                            <div class="listBtn" style="float:right">
                                <!-- <p class="listBtn1">查看详情</p>
                                <p class="listBtn2">物流跟踪</p>-->
                                <p class="listBtn1 shou" @click="goDetailsCF(item.id)">订单详情</p>
                                <!-- 待支付 -->
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 0"
                                    @click="cancel(item.id)"
                                >取消订单</p>
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 0"
                                    @click="payment(item.id)"
                                >立即付款</p>
                                <!-- 待收货 -->
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 4"
                                    @click="logistics(item.id)"
                                >查看物流</p>
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 4"
                                    @click="ConfirmReceipt(item.id)"
                                >确认收货</p>
                                <!-- 等待评价 -->
                                <p
                                    class="listBtn1 shou"
                                    v-if="item.optDdzt == 5 && item.optDdzt != 10"
                                    @click="evaluateCF(item.id,item.spSpgl)"
                                >立即评价</p>
                                <!-- <p class="listBtn1" v-if="item.optDdzt == 5 && item.optDdzt != 9">开具发票</p> -->
                              
                            </div>
                        </div>
                    </div>
                        
                </div>
                <p class="more" @click="goMore()">
                    <span>加载更多</span>
                    <i class="el-icon-caret-bottom"></i>
                </p>
            </div>
            <div class="left-bottom">
                <h3>
                    <span>热销商品</span>
                </h3>
                <div class="shopLists">
                    <div class="shop" v-for="(item,index) in hotList" :key="index">
                        <div class="shopImg" @click="goDetail(item.id,1)">
                            <img :src="$store.state.imgUrl+item.atCoverUrl" alt />
                        </div>
                        <p class="shopTitle">{{item.atSpmc}}</p>
                        <div class="shopMoney">
                            <span class="shopMoney1">￥{{item.atYpdj}}</span>
                            <span class="monthSale">月销 {{item.monthSaleCount?item.monthSaleCount:0}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mainRight">
            <div class="mainRight-top">
                <div class="myYA">
                    <span class="myYA-t">我的医案</span>
                    <span class="fr shou" @click="goYA">
                        更多
                        <i class="el-icon-d-arrow-right"></i>
                    </span>
                </div>
                <div class="myYA-c">
                    <div v-for="(item,index) in dataList" :key="index" @click="edit(item.id)">
                        <el-row class="myYA-c-per shou">
                            <el-col :span="4">
                                <img
                                    :src="require('@/assets/img/nan.png')"
                                    alt
                                    v-if="item.sex ==='男'"
                                />
                                <img :src="require('@/assets/img/nv.png')" alt v-else />
                            </el-col>
                            <el-col :span="20" class="setFont">
                                <div>
                                    <span class="name1">{{limitMaxWords(6,item.name)}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span>年龄:{{item.age}}</span>
                                    <span class="fr">
                                        <i class="el-icon-arrow-right"></i>
                                    </span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="center">
                        <el-button type="danger" class="red addButton" @click="addYA">
                            <i class="el-icon-circle-plus-outline"></i>
                            新增
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="mainRight-btm">
                <div class="myYA">
                    <span class="myYA-t">我的收藏</span>
                    <span class="fr shou" @click="goSC()">
                        更多
                        <i class="el-icon-d-arrow-right"></i>
                    </span>
                </div>
                <div class="myYA-c">
                    <div class="Collection" v-for="(item,index) in datalist" :key="index">
                        <div class="CollectionImg" @click.stop="goDetail(item.id,item.show)">
                            <img :src="$store.state.imgUrl+item.atPhotoUrl" alt />
                        </div>
                        <div class="CollectionRight">
                            <p
                                class="shopTitle"
                                @click.stop="goDetail(item.id,item.show)"
                            >{{item.atSpmc}}</p>
                            <div class="shopMoney">
                                <span class="shopMoney1" v-if="item.optYhlx==3">￥{{item.atYpdj}}</span>
                                <span
                                    class="shopMoney1"
                                    v-if="item.optYhlx==2 || item.optYhlx==1"
                                >￥{{item.yhjg}}</span>
                                <!-- <span class="shopMoney1">￥66.00</span> -->
                                <!-- <span class="shopMoney2">/{{item.atBzgg}}</span> -->
                                <span class="monthSale">月销 {{item.monthSaleCount?item.monthSaleCount:0}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import all from "@/assets/list/all.png";
import dfk from "@/assets/list/dfk.png";
import dfh from "@/assets/list/dfh.png";
import dsh from "@/assets/list/dsh.png";
import dpj from "@/assets/list/dpj.png";
export default {
    name: "PersonalCenter",
    data() {
        return {
            navList: [
                {
                    img: all,
                    title: "全部订单"
                },
                {
                    img: dfk,
                    title: "待付款"
                },
                {
                    img: dfh,
                    title: "待发货"
                },
                {
                    img: dsh,
                    title: "待收货"
                },
                {
                    img: dpj,
                    title: "待评价"
                }
            ],
            dataList: [],
            list: [],
            i1: 0,
            userInfo: {},
            userId: "",
            type: "6", //收藏商品
            datas: [], //我的收藏回显所有数据
            datalist: [], //我的收藏数据
            optDdzt: "",
            hotList:[]
        };
    },
    created() {
        this.getList(); //获取医案
        this.getData(); //获取收藏
        this.getOrder(); //获取订单
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.userId = this.userInfo.id;
        }
        this.gethotSell() // 热销商品
    },
    methods: {
        //热销商品
        gethotSell () {
            let params = {}

            let url = "collection/hotProduct";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                     this.hotList = res.data.data;
                }
            });

        },

        //收藏列表
        getData() {
            var params = {};
            params.userId = this.userInfo.id;
            params.collectionType = this.type;
            params.pageSize = "3";
            //商城
            params.pageNum = "1";

            let url = "/collection/page";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    // console.log(res, 456);
                    this.datas = res.data.data;
                    this.datalist = res.data.data.list;
                    if (this.type == "6") {
                        for (var j = 0; j < this.datalist.length; j++) {
                            this.datalist[j].atPhotoUrl = this.datalist[
                                j
                            ].atPhotoUrl.split(",")[0];
                        }
                    }
                }else{
                    that.$message.error(res.data.msg);
                }
            });
        },
        goDetail(id, show) {
            //我的收藏跳转详情
            if (show == 0) {
                this.$message({
                    type: "warning",
                    message: "已下架"
                });
                return false;
            }
            //跳转详情
            console.log(id);
            this.$router.push({ path: "/ProductDetails/" + id });
        },
        goSC() {
            sessionStorage.setItem("leftIndex1", 2);
            this.$router.push({ path: "/myCollection" });
            // 刷新兄弟组件
            let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
            this.$router.push(NewPage);
            this.$router.go(-1);
        },
        //医案列表
        getList() {
            let that = this;
            if (sessionStorage.getItem("userInfo")) {
                this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            }
            let params = {
                userId: that.userInfo.id,
                pageNum: 1,
                pageSize: 3
            };
            let url = "medicalCasesPc/getYaByUserId";
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.dataList = res.data.list;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        //去医案
        goYA() {
            sessionStorage.setItem("leftIndex1", 1);
            this.$router.push({
                path: "/myYiAn",
                query: { yian: true }
            });
            // 刷新兄弟组件
            let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
            this.$router.push(NewPage);
            this.$router.go(-1);
        },
        //新增医案
        addYA() {
            sessionStorage.setItem("leftIndex1", 1);
            this.$router.push({
                path: "/addMedical"
            });
            // 刷新兄弟组件
            let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
            this.$router.push(NewPage);
            this.$router.go(-1);
        },
        edit(id) {
            sessionStorage.setItem("leftIndex1", 1);
            this.$router.push({
                path: "/addMedical",
                query: { id: id }
            });
            // 刷新兄弟组件
            let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
            this.$router.push(NewPage);
            this.$router.go(-1);
        },
        select(index) {
            this.i1 = index;
            if (index == 0) {
                this.optDdzt = "";
            } else if (index == 1) {
                this.optDdzt = 0;
            } else if (index == 2) {
                this.optDdzt = 3;
            } else if (index == 3) {
                this.optDdzt = 4;
            } else {
                this.optDdzt = 5;
            }

            this.getOrder();
            console.log(this.i1);
        },
        getOrder() {
            var params = {};
            params.createBy = this.userInfo.id;
            params.optDdzt = this.optDdzt;
            if (this.searchFlag) {
                params.search = this.searchVal;
            }
            params.pageSize = 4;
            params.pageNum = 1;
            let url = "/ddgl/getAppIndexListV2";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.list;
                }else{
                    that.$message.error(res.data.msg);
                }
            });
        },
        goDetails(id) {
            this.$router.push({ path: "/OrderDetails", query: { id: id } });
        },
        goDetailsCF(id) {
            this.$router.push({ path: "/OrderCFDetails", query: { id: id } });
        },
        cancel(id) {
            //取消订单
            this.$confirm("此操作将取消该订单, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                var params = {};
                params.id = id;
                let url = "/ddgl/qxUpdate";
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: "success",
                            message: "取消成功!"
                        });
                        this.getOrder();
                    }else{
                        that.$message.error(res.data.msg);
                    }
                });
            });
        },
        ConfirmReceipt(id) {
            //确认收货
            var params = {};
            params.id = id;
            let url = "/ddgl/qrshUpdate";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "确认收货成功!"
                    });
                    this.getOrder();
                }else{
                    that.$message.error(res.data.msg);
                }
            });
        },
        payment(id) {
            //支付
            this.$router.push({ path: "/payment", query: { id: id } });
        },
        evaluate(id, spSpgl) {
            //商品评价
            this.$router.push({
                path: "/evaluate",
                query: { id: id, spSpgl: spSpgl }
            }); //传输订单明细id+商品id
        },
        evaluateCF(id, spSpgl){
            //药方评价
            this.$router.push({
                path: "/evaluateCf",
                query: { id: id, spSpgl: spSpgl }
            }); //传输订单明细id+商品id
            },
        logistics(id) {
            //查看物流
            this.$router.push({ path: "/logistics", query: { id: id } });
        },
        Repurchase(id, atType) {
            //再次购买
            this.$confirm("是否再次购买该订单下的所有商品?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                var params = {};
                params.id = id;
                let url = "/ddgl/againPayV2";
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        if (atType == 1) {//订单类型 1：普通订单 2：处方订单
                            let data={};
                            data.userId = this.userId;
                            let list =res.data.data.spgl;
                            var arr = [];
                            for (var i = 0; i < list.length; i++) {
                                    arr.push({
                                        spSpgl: list[i].id,
                                        atSpsl: list[i].atSpsl,
                                        spSpgg : list[i].spSpgg, //规格的id
                                        spSpggDetail : list[i].spSpggDetail, //规格明细的id
                                        isWholesale : list[i].atSpsl > list[i].wholesaleCount || list[i].atSpsl ==list[i].wholesaleCount ? 1 : 0,//是否批发 0：否，1：是
                                        spYhxx:list[i].optYhlx == 1? list[i].yhxxId:null
                                    });
                            }
                            data.ddmxList = arr;
                            sessionStorage.setItem("ddmxList", JSON.stringify(data)); //存储获取订单所需数据
                            this.$router.push({
                                path: "/ReceivingAddress",
                                query: { type: 1 } //type:生成订单入口区分（0 商品详情生成订单 1：购物车生成订单）
                            });
                        } else if(atType == 2) {
                            this.$router.push({
                                path: "/ReceivingAddress2",
                                query: { id: res.data.data.prescription.id } //type:生成订单入口区分（0 商品详情生成订单 1：购物车生成订单）
                            });
                        }

                        // this.$router.push({
                        //   path: "/payment",
                        //   query: { id: res.data.data.id }
                        // });
                    }else{
                      this.$message(res.data.msg);
                    }
                });
            });
        },
        goMore(){//加载更多订单状态
            sessionStorage.setItem("orderIndex",this.i1);
            this.$router.push({path: "/myOrder"})
        },

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#PersonalCenter {
    width: 100%;
}
#PersonalCenter::after {
    content: "";
    height: 0px;
    display: block;
    overflow: hidden;
    clear: both;
    visibility: hidden;
}
.mainLeft {
    float: left;
    width: 68%;
    /* background: chartreuse; */
    margin-right: 2%;
}
.mainLeft::after {
    content: "";
    height: 0px;
    display: block;
    overflow: hidden;
    clear: both;
    visibility: hidden;
}
.mainRight {
    float: left;
    width: 30%;
    /* background:chocolate; */
}
.mainRight::after {
    content: "";
    height: 0px;
    display: block;
    overflow: hidden;
    clear: both;
    visibility: hidden;
}
.left-top {
    box-sizing: border-box;
    padding: 0 20px;
    padding-top: 10px;
    border: 1px solid #dddddd;
    background: #fff;
}
.admin {
    clear: both;
    height: 60px;
    border-bottom: 1px solid #dddddd;
}
.admin .admin1 {
    float: left;
    width: 60%;
    height: 100%;
}
.admin1 p:nth-child(1) {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    float: left;
    margin-right: 10px;
}
.admin1 p:nth-child(1) img {
    width: 100%;
    min-height: 100%;
}
.admin1 p:nth-child(2) {
    width: 50px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0px;
    color: #333333;
}
.admin1 p:nth-child(2) {
    float: left;
    width: 50%;
}
.admin .admin2 {
    height: 100%;
    float: left;
}
.admin2 p {
    float: left;
    height: 50px;
    line-height: 50px;
}
.admin2 p:nth-child(1) {
    color: #999999;
}
.admin2 p:nth-child(2) {
    color: #333333;
}
.topNav {
    clear: both;
    width: 100%;
    height: 80px;
}
.topNav li {
    float: left;
    width: 16%;
    height: 79px;
    margin: 0 10px;
    cursor: pointer;
}
.topNav li.active {
    border-bottom: 3px solid #f64420;
}
.topNav li .navImg {
    width: 100%;
    height: 40px;
    margin-top: 10px;
}
.topNav li .navImg img {
    width: 50px;
    height: 100%;
    display: block;
    margin: 0 auto;
}
.topNav li .navTitl {
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #333333;
}
.left-middle {
    width: 100%;
    /* height: 385px; */
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid #dddddd;
    margin-top: 10px;
    background: #fff;
}

.orderList {
    /* height: 325px; */
    width: 100%;
    overflow-y: auto;
}
.listWrap {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    padding: 10px;
}
.listWrap2{
    width: 100%;
}
.listWrap div {
    float: left;
}
.listImg {
    width: 84px;
    height: 60px;
    overflow: hidden;
    cursor: pointer;
}
.listImg img {
    width: 100%;
    min-height: 100%;
}
.listTxt {
    width: 25%;
    height: 60px;
    margin-left: 10px;
}
.listTxt p {
    height: 30px;
    line-height: 30px;
    cursor: pointer;
}
.listTxt .listTxt2 {
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    color: #999999;
    cursor: pointer;
}
.listBtn {
    /* width: 55%; */
    height: 60px;
    margin-left: 10px;
}
.listBtn p {
    float: left;
    width: 68px;
    height: 30px;
    background-color: #fbf9f9;
    border-radius: 2px;
    border: solid 1px #dddddd;
    font-size: 13px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
}
.listBtn .listBtn1 {
    margin-right: 3px;
}
.more {
    width: 88px;
    height: 26px;
    line-height: 26px;
    background-color: #fbf9f9;
    border-radius: 2px;
    border: solid 1px #dddddd;
    text-align: center;
    cursor: pointer;
    margin: 10px auto;
}
.left-bottom {
    width: 100%;
    background: #fff;
    border: solid 1px #dddddd;
    margin-top: 20px;
}
.left-bottom::after {
    content: "";
    height: 0px;
    display: block;
    overflow: hidden;
    clear: both;
    visibility: hidden;
}
.left-bottom h3 {
    width: 100%;
    height: 44px;
    line-height: 44px;
    background-color: #eeeeee;
    border: solid 1px #dddddd;
    text-indent: 20px;
    margin: 0px;
}
.shopLists {
    box-sizing: border-box;
    padding: 20px 20px;
}
.shop {
    float: left;
    width: 30.6%;
    margin-right: 20px;
    margin-bottom: 20px;
}
.shop:nth-child(3n + 3) {
    margin-right: 0px;
}
.shopImg {
    width: 100%;
    height: 120px;
    background-color: #d3d3d3;
    overflow: hidden;
    cursor: pointer;
}
.shopImg img {
    width: 100%;
    min-height: 100%;
}
.shopTitle {
    margin-top: 10px;
    height: 36px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: 1px;
    color: #777;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    cursor: pointer;
}
.shopMoney {
    margin-top: 5px;
}
.shopMoney1 {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #f64420;
    cursor: pointer;
}
.shopMoney2 {
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #666666;
    cursor: pointer;
}
.monthSale{
float: right;
color: #999;
}
/* 我的医案样式 */
.mainRight-top,
.mainRight-btm {
    background: #fff;
}
.myYA {
    padding: 16px;
    height: 10px;
    line-height: 10px;
    background-color: #eeeeee;
    border: solid 1px #dddddd;
    border-bottom: none;
}
.myYA-t {
    font-weight: bold;
}
.myYA-c {
    padding: 20px 16px 12px 16px;
    border: solid 1px #dddddd;
}
.setFont {
    color: #999999;
    padding-left: 10px;
}
.name1 {
    letter-spacing: 1px;
    color: #303030;
}
.myYA-c-per {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
}
.center {
    text-align: center;
}
.addButton {
    width: 150px;
    height: 32px;
    padding: 0px;
}

/* 我的收藏 */
.mainRight-btm {
    margin-top: 20px;
}
.Collection {
    width: 100%;
    height: 75px;
    margin-bottom: 20px;
}
.Collection:last-child {
    margin-bottom: 10px;
}
.CollectionImg,
.CollectionRight {
    float: left;
    height: 100%;
}
.CollectionImg {
    width: 40%;
    overflow: hidden;
    cursor: pointer;
}
.CollectionImg img {
    width: 100%;
    min-height: 100%;
}
.CollectionRight {
    width: 55%;
    margin-left: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/JW/PersonalCenter.vue